// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"366":"faadc9bf","962":"daf25411"}[chunkId] + ".chunk.js";
};